import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { RuPrimaryButton } from '@silverrailtech/srtlibrary';
import messages from '../../messagesOuigoRefunds';
import SubmitActionWrapper from './styles';

const SubmitVouchersAction = ({
	isSubmitting,
	onSubmit,
	selectedVoucherCount,
}) => {
	const { formatMessage } = useIntl();
	const isDisabled = selectedVoucherCount === 0 || isSubmitting;

	return (
		<SubmitActionWrapper>
			<RuPrimaryButton
				aria-label={formatMessage(messages.lblSubmitForRefund)}
				disabled={isDisabled}
				isAsync={isSubmitting}
				onClick={onSubmit}
				type="button"
			>
				<FormattedMessage {...messages.lblSubmitForRefund} />
			</RuPrimaryButton>
		</SubmitActionWrapper>
	);
};

SubmitVouchersAction.propTypes = {
	isSubmitting: PropTypes.bool.isRequired,
	onSubmit: PropTypes.func.isRequired,
	selectedVoucherCount: PropTypes.number.isRequired,
};

export default SubmitVouchersAction;
